<template>
    <div class="container">
        <div class="innerList">
            <ul>
                <li v-for="(item,index) in list" :key="index"
                    :style="{backgroundImage: 'url(' + (item.bgUrl ? item.bgUrl : '') + ')'}">
                   <div class="innerCon">
                       <div class="innerTitlediv">
                           <p class="innerTitle">{{item.title}}</p>
                           <p class="contain">{{item.contain}}</p>
                       </div>
                       <div class="btnBOx">
                           <p v-if="isOpen">我要申请</p>
                           <p v-else class="isFlaseStyle">即将开放申请</p>
                       </div>
                   </div>
                </li>
                <li style="min-height: 75px">
                    <div style="border-radius: 10px;overflow: hidden">
                        <img src="../../assets/images/cooperation/bg_hezuoNo.png" width="100%" height="100%" alt="">
                    </div>
                </li>
            </ul>


        </div>
    </div>
</template>

<script>
    export default {
        name: "cooperation",
        data(){
            return{
                list:[
                    {
                        id:1,
                        title:'超级回收员',
                        contain:'超级回收员火热招募中，收入稳定，就来搭把手吧！',
                        isOpen:false, //判断是否展示 ‘我要申请’
                        bgUrl:require('@/assets/images/cooperation/bg_hezuo1.png')
                    },
                    {
                        id:2,
                        title:'超级回收员',
                        contain:'超级回收员火热招募中，收入稳定，就来搭把手吧！',
                        isOpen:false, //判断是否展示 ‘我要申请’
                        bgUrl:require('@/assets/images/cooperation/bg_hezuo2.png')
                    },
                    {
                        id:3,
                        title:'超级回收员',
                        contain:'超级回收员火热招募中，收入稳定，就来搭把手吧！',
                        isOpen:false, //判断是否展示 ‘我要申请’
                        bgUrl:require('@/assets/images/cooperation/bg_hezuo1.png')
                    },

                ]
            }
        }
    }
</script>

<style scoped>

    .container{
        background-color: #F8F8F8;
        min-height: 100vh;
    }
    .nav_title{
        height: 60px;
        width: 100%;
        position: fixed;
        line-height: 60px;
        background-color: white;
        text-align: center;
        color: #030303;
        font-size: 16px;
        font-weight: 600;
    }
    .nav_title .imgBox{
        position: absolute;
        left: 15px;
        top: -2px;
    }
    .innerList{
        padding: 20px 15px;
    }
    .innerList ul{
        padding:0 7px 7px 5px;
    }
    .innerCon{
        display: flex;
        padding: 15px;
        align-items:center;
        min-height: 75px;
    }
    .innerTitlediv{
        width: 164px;
    }
    .innerTitle{
        font-size: 14px;
        font-weight: 600;
    }
    .btnBOx{
        margin-left: 20px;
    }
    .btnBOx p {
        font-size: 14px;
        width: 120px;
        border-radius: 28px;
        padding: 8px 0;
        text-align: center;
    }
    .isFlaseStyle{
        color: white;
        background-color:#DEDEDE ;
        box-shadow:0px 4px 14px 0px rgba(211,211,211,0.59);
    }
    .contain{
        font-size: 12px;
    }
    .innerList ul li{
        box-shadow:0px 0px 20px 0px rgba(0,0,0,0.04);
        margin-top: 10px;
        border-radius: 12px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
</style>
